import './index.sass';

export default () => {
  function processResponse(data) {
    $('.js-list').find('div.js-list-item').each(function () {
      $(this).remove();
    });
    const pagination = $('nav.pagination');
    if($('.js-period-select').length) {
      $('.js-period-select').toggle(data.show_period)
    }

    if (data.stub) {
      $('.js-list').append($(data.stub));
      pagination.html('');
      if($('.js-period-select').length) {
        $('.js-period-select').toggle(false);
      }
      return
    }

    if (data.items) {
      $('.feeds__item').remove();
      $('.js-list').append($(data.items));
      $('.feeds__pagination').html()
      pagination.html(data.pagination);
      return
    }
    $(data.posts).each(function () {
      var s = $(this);
      $('.js-list').append(s);
      s.hide().fadeIn(600);
    });

    pagination.html(data.page_section);
  }

  $(document).on('ajax:success', 'a.js-sort-link', function (e) {
    const data = e.detail[0];
    $('a.js-sort-link').removeClass('switches__controls-link--active');
    $(this).addClass('switches__controls-link--active');
    processResponse(data);
  });

  $('[data-filter]').click(function() {
    $('#filter').val($(this).data('filter'));
    return $(this).closest('form').submit();
  });

  $('#sort').change(function() {
    $('#sort_by').val($(this).val())
    return $(this).closest('form').submit();
  })

  $('.js-select').on('change', function () {
    $(this).find('option').filter((index,item) => {
      if($(this).val() === $(item).val()){
        if($(item).data('href').length) {
          if($(this).hasClass('js-select-feeds')) {
            window.location = $(item).data('href')
          } else {
            $(this).attr('data-href', $(item).data('href'));
            const link = $(this).attr('data-href');
            $.get(link, function(data) {
              processResponse(data)
            });
          }
        }
        // let resp = $.get(link);
        // resp.success(function (data) {
        //   processResponse(data)
        // });
      }
    })
  });

  const $filterBtn = $('.js-filter-show');
  if($filterBtn.length) {
    $filterBtn.on('click', () => {
      $('.js-filter-list').toggleClass('users__filters--show');
    })
  }

 const $filterFeeds = $('.js-filter-feeds');
  if($filterFeeds.length) {
    $filterFeeds.on('click', () => {
      $('.switches__select-wrap').slideToggle();
    })
  }

}